import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import "./markdown.css"

const MarkdownRenderer = ({ filePath }) => {
    const [markdown, setMarkdown] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        setError(null);

        fetch(filePath)
            .then((response) => {
                const contentType = response.headers.get('content-type') ?? '';

                if (!response.ok || contentType.includes('text/html')) {
                    throw new Error(`Unable to load Markdown: ${filePath}`);
                }

                return response.text();
            })
            .then((text) => setMarkdown(text))
            .catch((error) => {
                console.error(error);
                setMarkdown('');
                setError('This article could not be loaded.');
            });
    }, [filePath]);

    if (error) {
        return <p role="alert">{error}</p>;
    }

    return (
        <div className="markdown-body">
            <ReactMarkdown
                children={markdown}
                components={{
                    code({ node, inline, className, children, ...props }) {
                        const match = /language-(\w+)/.exec(className || '');

                        return !inline && match ? (
                            <SyntaxHighlighter
                                language={match[1]}
                                style={oneDark}
                                PreTag="div"
                                {...props}
                            >
                                {String(children).replace(/\n$/, '')}
                            </SyntaxHighlighter>
                        ) : (
                            <code className={className} {...props}>
                                {children}
                            </code>
                        );
                    }
                }}
            />

        </div>
    );
};

export default MarkdownRenderer;
